/* dcl-pdp-m.js (Nov 4, 2026)
   Phone accordions for the DCL product pages.
   Tech and parts (template product.dcl): turns the Specs, In the box / Works with,
   What's new and Guides sections into tap-to-open rows. Overview, add-ons, FAQ and
   reviews stay as they are: the FAQ questions stay visible so shoppers can see what
   is there, and each answer opens with its own plus button.
   Bikes (template product.dcl-bike): turns each Build spec group (Frame and fork,
   Drivetrain and brakes, and so on) into a tap-to-open row. The size card and the
   Make it yours card above the groups stay open, and so does everything else.
   The text stays in the page either way; only the styling (assets/dcl-pdp-m.css,
   phone width only) hides it while a row is closed. */
(function () {
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function specs(n) { return n ? n + (n === 1 ? ' spec' : ' specs') : ''; }

  function build(sec, label, meta, bodyEl, anchorEl, startOpen) {
    if (!sec || !bodyEl || sec.classList.contains('dpdp-m-acc')) return;
    var id = 'dpdp-m-' + sec.id;
    var h = document.createElement('h2');
    h.className = 'dpdp-m-h';
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'dpdp-m-t';
    b.setAttribute('aria-controls', id);
    b.innerHTML = '<span class="dpdp-m-n"></span><span class="dpdp-m-meta"></span><span class="dpdp-m-s" aria-hidden="true"></span>';
    b.querySelector('.dpdp-m-n').textContent = label;
    b.querySelector('.dpdp-m-meta').textContent = meta || '';
    h.appendChild(b);
    anchorEl.parentNode.insertBefore(h, anchorEl);
    bodyEl.id = id;
    bodyEl.classList.add('dpdp-m-body');
    sec.classList.add('dpdp-m-acc', 'dpdp-m-hh');
    function set(open) {
      sec.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.querySelector('.dpdp-m-s').textContent = open ? '−' : '+';
    }
    b.addEventListener('click', function () { set(!sec.classList.contains('is-open')); });
    sec._dpdpOpen = function () { set(true); };
    set(!!startOpen);
  }

  function init() {
    var root = document.querySelector('.dpdp');
    if (!root) return;
    var q = function (s) { return root.querySelector(s); };
    var made = false;

    var groups = root.querySelectorAll('.dbk-groups .dbk-group');
    if (groups.length) {
      // Bike: one row per Build spec group. The first group starts open.
      [].forEach.call(groups, function (g, i) {
        var dl = g.querySelector('.dpdp-specs');
        if (!dl) return;
        if (!g.id) g.id = 'dpdp-g-' + (i + 1);
        var n = dl.querySelectorAll('.dpdp-spec').length;
        build(g, txt(g.querySelector('.dpdp-h3')) || 'Details', specs(n), dl, dl, i === 0);
        made = true;
      });
    } else {
      var sp = q('#dpdp-specs');
      if (sp) {
        var sw = sp.querySelector('.dpdp-wrap');
        var n = sp.querySelectorAll('.dpdp-spec').length;
        build(sp, txt(sp.querySelector('.dpdp-h2')) || 'Specs', specs(n), sw, sw, true);
        made = true;
      }

      var box = q('#dpdp-box');
      if (box) {
        var bw = box.querySelector('.dpdp-wrap');
        var names = [].map.call(box.querySelectorAll('.dpdp-h3'), txt).filter(Boolean);
        build(box, names.join(' and ') || 'In the box', '', bw, bw, false);
        made = true;
      }

      var nw = q('#dpdp-new');
      if (nw) {
        var nww = nw.querySelector('.dpdp-wrap');
        build(nw, "What's new", '', nww, nww, false);
        made = true;
      }

      var gd = q('#dpdp-guides');
      if (gd) {
        var gw = gd.querySelector('.dpdp-wrap');
        var gc = gd.querySelectorAll('.dpdp-guides > *').length;
        build(gd, 'Guides from the Lab', gc ? String(gc) : '', gw, gw, false);
        gd.classList.add('dpdp-m-guides');
        made = true;
      }
    }

    if (made) root.classList.add('dpdp-m-on');

    function openFor(hash) {
      if (!hash || hash.charAt(0) !== '#') return;
      var t = document.getElementById(hash.slice(1));
      var s = t && t.closest ? t.closest('.dpdp-m-acc') : null;
      if (s && s._dpdpOpen) s._dpdpOpen();
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#dpdp-"]');
      if (a) openFor(a.getAttribute('href'));
    });
    window.addEventListener('hashchange', function () { openFor(location.hash); });
    openFor(location.hash);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
